import React from 'react';

import { SVGComponentProps } from './svg.types';

const MailTwoSVG = ({ fill = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M8.87832 14.0013C8.65635 13.9919 8.48954 13.8517 8.38102 13.6171C7.92392 12.6322 7.46502 11.6485 7.00434 10.666C6.71779 10.0527 6.43483 9.43755 6.14201 8.82737C6.0882 8.71549 6.10524 8.65303 6.18954 8.56946C6.96174 7.80381 7.73109 7.03562 8.49761 6.26488C8.64111 6.12155 8.72631 5.95889 8.66398 5.75086C8.63635 5.64706 8.58037 5.55305 8.50234 5.47939C8.42431 5.40572 8.32732 5.35534 8.22227 5.33388C8.01958 5.28446 7.86577 5.37477 7.729 5.51361C6.96936 6.27746 6.20658 7.03457 5.44963 7.79887C5.35995 7.89143 5.29313 7.91345 5.16533 7.85324C3.57609 7.10437 1.98447 6.36104 0.390451 5.62325C0.194487 5.53338 0.0509896 5.40443 0.0115278 5.18696C-0.0391447 4.90927 0.11377 4.67832 0.411975 4.57273C1.41377 4.21777 2.41526 3.8634 3.41645 3.50963C6.67504 2.35877 9.93363 1.2076 13.1922 0.0561384C13.4366 -0.0301316 13.6541 -0.026537 13.8429 0.163976C14.0317 0.354489 14.0299 0.563424 13.946 0.800666C12.4465 5.04557 10.9483 9.29152 9.45142 13.5385C9.34648 13.8423 9.16397 13.9982 8.87832 14.0013Z"
        fill={fill}
      />
    </svg>
  );
};

export default MailTwoSVG;
